import { IConsultantProfile } from "../types-ensure";

export const hasPendingRequestToJoin = (profile: IConsultantProfile) =>
  profile.requestToJoin && profile.status === "PENDING";
